import React, { useEffect, useState } from 'react'
import FormInputs from '../../../../components/UI/FormInputs';
import { formatDate, getCurrentDate, getCurrentTime, isSet } from '../../../../utils/commonUtils'
import WithRoutify from '../../../../hoc/WithRoutify';
import Buttons from '../../../../components/UI/Buttons';
import Alert from '../../../../components/UI/ConfirmBox/Alert';
import EmrVisitsService from '../../../../services/EmrVisitsService';
import EmrConfigService from '../../../../services/EmrConfigService';
import UserService from '../../../../services/UserService';
import FileManagerService from '../../../../services/FileManagerService';
import Icons from '../../../../components/UI/Icons';

const SchoolNoteTab = (props) => {
      const {setIsChartingSectionDirty,showUnsavedAlert,setShowUnsavedAlert,pendingCallback,setPendingCallback} = props;
      const [formData, setFormData] = React.useState({});
      const [isSendingEmail, setIsSendingEmail] = React.useState(false);
      const visitRecord = props?.visitDetails?.["0"] ?? props?.visitDetails ?? {};
      const patientNameFromVisit = visitRecord?.patient_name || visitRecord?.employee_name || `${visitRecord?.employee?.first_name || ''} ${visitRecord?.employee?.last_name || ''}`.trim();
      const patientNameFromEmployee = `${props?.employeeDetails?.first_name || ''} ${props?.employeeDetails?.last_name || ''}`.trim();
      const patientName = patientNameFromVisit || patientNameFromEmployee;
      const normalizeVisitDate = (rawDate) => {
            const value = String(rawDate || '').trim();
            if (!value) return '';
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
            const ts = Date.parse(value);
            if (Number.isNaN(ts)) return '';
            return formatDate(new Date(ts));
      };
      const visitDate = normalizeVisitDate(visitRecord?.visit_date);
      useEffect(() => {
            fetchSchoolNoteData();
      }, [props.isrenderIncident]);

      useEffect(() => {
            props.fetchProgressNotesByScreen();
      }, [props.selectedSubTab]);

      useEffect(() => {
            if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
                  fetchSchoolNoteData();
                  setFormData({});
            }
      }, [props.refreshEmrTrigger]);
//Input fields for school note
const inputField = [
            {
                  type: "TextInput",
                  label: "Patient Name",
                  placeholder: "Patient Name",
                  className: "form-control form-control-solid",
                  name: "patient_name",
                  readOnly: true,
                  col: 'col-6',
            },
            {
                type: "Date",
                label: "Date of Visit",
                placeholder: "Date",
                className: "form-control form-control-solid",
                name: "visit_date",
                col: 'col-6',
                disabled: true,
            },
            {
                  type: "Radio",
                  label: "Excuse Type",
                  placeholder: "",
                  isLabelAppend: true,
                  className: "form-check-input",
                  name: "excuse_type",
                  col: 'col-6',
                  optionss: [
                        { label: "School", value: "School" },
                        { label: "Work", value: "Work" },
                        { label: "Sports / PE", value: "Sports / PE" },
                  ]
            },
            {
                  type: "Date",
                  label: "Excused From Date",
                  placeholder: "Start Date",
                  className: "form-control form-control-solid",
                  name: "excused_from_date",
                  col: 'col-6',
            },
            {
                  type: "Date",
                  label: "Excused To Date",
                  placeholder: "End Date",
                  className: "form-control form-control-solid",
                  name: "excused_to_date",
                  col: 'col-6',
            },
            {
                  type: "Date",
                  label: "Return Date",
                  placeholder: "Return Date",
                  className: "form-control form-control-solid",
                  name: "return_date",
                  col: 'col-6',
            },
            {
                  type: "Checkbox",
                  label: "Return Status",
                  placeholder: "",
                  isLabelAppend: true,
                  className: "form-check-input",
                  name: "return_status",
                  col: 'col-6',
                  optionss: [
                        { label: "Full duty / no restrictions", value: "Full duty / no restrictions" },
                        { label: "Modified duty", value: "Modified duty" },
                        { label: "Not cleared until", value: "Not cleared until" },
                  ]
            },
            {
                  type: "Date",
                  label: "Not Cleared Until Date",
                  placeholder: "Date",
                  className: "form-control form-control-solid",
                  name: "not_cleared_until_date",
                  col: 'col-6',
            },
            {
                  type: "TextArea",
                  label: "Clinical Notes (Optional)",
                  placeholder: "Brief justification or diagnosis",
                  className: "form-control form-control-solid",
                  name: "clinical_notes",
                  col: 'col-12',
            },
      ];

      const onChangeHandler = (name, value, e, type) => {
            if (setIsChartingSectionDirty) {
                  setIsChartingSectionDirty(true);
            }
            if (type === "Checkbox") {
                  let newArray = formData[name]
                        ? formData[name].split(",").filter((item) => item)
                        : [];
                  if (e.e.target.checked) {
                        if (!newArray.includes(value)) {
                              newArray.push(value);
                        }
                  } else {
                        newArray = newArray.filter((item) => item !== value);
                  }
                  value = newArray.join(",");
            }
            setFormData((prevState) => ({
                  ...prevState,
                  [name]: value,
            }));
      };
      const fetchSchoolNoteData = async () => {
            try {
                  props.Loader(true);
                  const response = await EmrVisitsService.getSchoolNoteById(props.visit_id);
                  if (response == null) {
                        setFormData({});
                  } else {
                        setFormData(response);
                  }
            } catch (err) {
            } finally {
                  props.Loader(false);
            }
      };

      const saveHandler = async () => {
            try {
                  props.Loader(true);
                  const payload = {
                        ...formData,
                        patient_name: patientName,
                        visit_date: visitDate,
                  };
                  const res = await EmrVisitsService.SaveSchoolNote(props.visit_id, payload);
                  if (res.code === 200) {
                        props.fetchProgressNotesByScreen();
                        setFormData({});
                        fetchSchoolNoteData();
                        props.SetFinishedTabs((prev) => (Array.from(new Set([...prev, props.selectedTab]))));
                        props.SetFinishedSubTabs((prev) => (Array.from(new Set([...prev, props.selectedSubTab]))));
                        handleTick(
                              Array.from(new Set([...props.finishedTabs, props.selectedTab])),
                              Array.from(new Set([...props.finishedSubTabs, props.selectedSubTab]))
                        );
                        props.Toast.success("Data saved successfully!");
                        if (setIsChartingSectionDirty) {
                              setIsChartingSectionDirty(false);
                        }
                        return true;
                  }
            } catch (err) {
                  props.Toast.error("Something went wrong!");
                  return false;
            } finally {
                  props.Loader(false);
            }
      };

      const handleTick = async (maintabs, subtabs) => {
            try {
                  const payload = props.tabData.map((tab) => ({
                        ...tab,
                        tab_status: maintabs.includes(tab.tab_name) ? "COMPLETED" : "NOT STARTED",
                        [tab.tab_name]: tab[tab.tab_name]?.map((subtab) => ({
                              ...subtab,
                              sub_tab_status: subtabs.includes(subtab.apikey)
                                    ? "COMPLETED"
                                    : "NOT STARTED",
                        })) || [],
                  }));
                  const response = await EmrConfigService.setTabsListstatus(props.visit_id, payload, props.VISITCATEGORY);
                  if (response) {
                        props.fetchTabsList();
                  }
            } catch (err) {
                  // silently handle
            }
      };

      const handleIncomplete = () => {
            if (setIsChartingSectionDirty) setIsChartingSectionDirty(false);
            props.SetFinishedTabs((prev) => prev.filter(tab => tab !== props.selectedTab));
            props.SetFinishedSubTabs((prev) => prev.filter(subtab => subtab !== props.selectedSubTab));
            handleTick(
                  props.finishedTabs.filter(tab => tab !== props.selectedTab),
                  props.finishedSubTabs.filter(subtab => subtab !== props.selectedSubTab)
            );
      };

      const ClearHandler = async () => {
            const cleardata = {
                  ...formData,
                  patient_name:'',
                  visit_date: '',
                  excuse_type: '',
                  excused_from_date: '',
                  excused_to_date: '',
                  return_date: '',
                  return_status: '',
                  not_cleared_until_date: '',
                  clinical_notes: '',
                  provider_signature: '',
                  signed_user_name: '',
                  signed_date: '',
            };
            try {
                  props.Loader(true);
                  const res = await EmrVisitsService.SaveSchoolNote(props.visit_id, cleardata);
                  if (res) {
                        props.Loader(false);
                        setFormData({});
                        fetchSchoolNoteData();
                        props.fetchProgressNotesByScreen();
                        handleIncomplete();
                        props.Toast.success("Data cleared successfully!");
                        if (setIsChartingSectionDirty) {
                              setIsChartingSectionDirty(false);
                        }
                  }
            } catch (err) {

            }
      };
      const handleProceed = () => {
            if (setIsChartingSectionDirty) setIsChartingSectionDirty(false);
            if (setShowUnsavedAlert) setShowUnsavedAlert(false);
            if (pendingCallback) pendingCallback();
            if (setPendingCallback) setPendingCallback(null);
      };
      const handleCancel = () => {
            if (setShowUnsavedAlert) setShowUnsavedAlert(false);
            if (setPendingCallback) setPendingCallback(null);
      };

      const getSignedInProviderName = () => {
            const profile = UserService.getProfile?.() || {};
            return profile?.username
                  || profile?.name
                  || `${profile?.first_name || ''} ${profile?.last_name || ''}`.trim();
      };

      const handleSignatureChange = (signatureValue) => {
            if (setIsChartingSectionDirty) {
                  setIsChartingSectionDirty(true);
            }
            setFormData((prevState) => {
                  const updatedData = {
                        ...prevState,
                        provider_signature: signatureValue || '',
                  };
                  if (signatureValue) {
                        updatedData.signed_user_name = prevState?.signed_user_name || getSignedInProviderName();
                        updatedData.signed_date = prevState?.signed_date || getCurrentDate();
                  } else {
                        updatedData.signed_user_name = '';
                        updatedData.signed_date = '';
                  }
                  return updatedData;
            });
      };

      const printSchoolNote = async () => {
            try {
                  props.Loader(true);
                  const response = await EmrVisitsService.printSchoolNote(props.visit_id);
                  const base64Data = typeof response === 'string' ? response : (response?.data || response);
                  if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
                        const pdfData = {
                              file_content: base64Data,
                              original_name: 'snap school note report',
                              mime_type: 'application/pdf',
                        };
                        FileManagerService.printPdf(pdfData);
                  } else {
                        props.Toast.error('Failed to generate school note PDF');
                  }
            } catch (error) {
                  props.Toast.error('Failed to print school note');
            } finally {
                  props.Loader(false);
            }
      };

      const sendSchoolNoteEmail = async () => {
            if (isSendingEmail) return;
            try {
                  setIsSendingEmail(true);
                  props.Loader(true);
                  const response = await EmrVisitsService.sendSchoolNoteEmail(props.visit_id);
                  if (response && (response.code === 200 || response.code === 201)) {
                        const patientEmail = visitRecord?.employee?.email || props?.employeeDetails?.email || '';
                        if (patientEmail) {
                              props.Toast.success(`School note sent successfully to patient (${patientEmail})`);
                        } else {
                              props.Toast.success('School note sent successfully to patient');
                        }
                  } else {
                        props.Toast.error(response?.data?.error || response?.message || 'Failed to send school note email');
                  }
            } catch (error) {
                  props.Toast.error('Failed to send school note email');
            } finally {
                  setIsSendingEmail(false);
                  props.Loader(false);
            }
      };

      return (
            <>
              <div className='row'>
                    <div className='col-12'>
                          <div className='card sh_basecard'>
                                <div className="card-header p-2 sh_basecardHeader">
                                    <div className="d-flex w-100 justify-content-between align-items-center">School Note
                                     <div className="d-flex" >
                                            {formData['school_note_id'] && 
                                          <div className="w-100 d-flex gap-2 justify-content-end mr-2">
                                            <a className="new-btn-icon" 
                                            title="Print School Note"
                                            onClick={printSchoolNote}
                                            >
                                              <Icons type="Print" size={16} />
                                            </a>
                                            <a className="new-btn-icon" 
                                            title="Send Email"
                                            onClick={sendSchoolNoteEmail}
                                            >
                                              <Icons type="Email" size={16} />
                                            </a>
                                          </div>}
                                                  {formData['school_note_id'] && <Buttons
                                                        clickHandler={() => ClearHandler()}
                                                        className="btn sh_btnlight p3-light mr-2"
                                                        acl={'any'}
                                                        isDelete={true}
                                                        label={"Clear All"} />}
                                                  <Buttons
                                                        clickHandler={() => saveHandler()}
                                                        className="btn btn-primary sh_btnprimary"
                                                        acl={'any'}
                                                        label={"Accept / Replace"} />
                                            </div>
                                      </div>
                                </div>
                                <div className="card-body p-2 sh_basecardBody">
                                      <div className='row'>
                                            {inputField.map((item, index) => {
                                                  let value = isSet(formData[item.name], '');
                                                  if (item.name === 'patient_name') {
                                                        value = patientName;
                                                  }
                                                  if (item.name === 'visit_date') {
                                                        value = visitDate;
                                                  }
                                                  return (
                                                        <div className="col-sm-12" key={index}>
                                                              <div className="form-group row">
                                                                    <label className="col-sm-3 form-group label">{item.label}</label>
                                                                    <div className="col-sm-9">
                                                                          {isSet(item.isLabelAppend, false) === true ?
                                                                                <div className='d-flex flex-wrap'>
                                                                                      {item?.optionss.map((opt, ind) => {
                                                                                            return (
                                                                                                  <div className="form-group sh_emrtableformgroup mb-0 col-3" key={ind}>
                                                                                                        <div className='form-check'>
                                                                                                              <FormInputs
                                                                                                                    {...item}
                                                                                                                    id={`${item.name}-${opt.label}`}
                                                                                                                    value={item.type === 'Checkbox' ? value && value.split(",").includes(opt.value) ? true : false : value === opt.value ? true : false}
                                                                                                                    changeHandler={(val, e) => { onChangeHandler(item.name, opt.value, e, item.type) }}
                                                                                                              />
                                                                                                              <label htmlFor={`${item.name}-${opt.label}`}>{opt.label}</label>
                                                                                                        </div>
                                                                                                  </div>
                                                                                            )
                                                                                      })}
                                                                                </div>
                                                                                :
                                                                                <FormInputs {...item} value={value} changeHandler={(val, e) => { onChangeHandler(item.name, val, e) }} />
                                                                          }
                                                                    </div>
                                                              </div>
                                                        </div>
                                                  )
                                            })}
                                      </div>
                                      <div className="col-sm-12 text-dark">
                                            <div className="form-group row mb-0">
                                                  <div className="col-sm-6">
                                                        <div className="mb-2">
                                                              <strong>Signature:</strong>
                                                              <div className="mt-1">
                                                                    <FormInputs
                                                                          type="NewSignature"
                                                                          value={isSet(formData?.provider_signature, '')}
                                                                          changeHandler={(val) => handleSignatureChange(val)}
                                                                    />
                                                              </div>
                                                        </div>
                                                        <div className="mb-2">
                                                              <strong>Provider Name:</strong> <strong>{isSet(formData?.signed_user_name, '')}</strong>
                                                        </div>
                                                        <div className="mb-3">
                                                              <strong>Signature Date:</strong> <strong>{isSet(formData?.signed_date, '')}</strong>
                                                        </div>
                                                </div>
                                            </div>
                                      </div>
                                </div>
                          </div>
                    </div>
              </div>
              {/* <div style={{display: "flex",justifyContent: "flex-end",padding: "10px"}}>
                    <Buttons
                          clickHandler={() => saveHandler()}
                          className="btn btn-primary sh_btnprimary"
                          acl={'any'}
                          label={"Accept / Replace"}
                    />
              </div> */}
              {showUnsavedAlert && (
                    <Alert
                          contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
                          content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
                          yesButtonName="Discard"
                          noButtonName="Cancel"
                          type="warning"
                          onDelete={handleProceed}
                          onClose={handleCancel}
                          confirmButtonClassName="btn btn-danger"
                          cancelButtonClassName="btn btn-secondary"
                          saveAndClose={true}
                          onSaveAndClose={async () => {
                                const success = await saveHandler();
                                if (success) {
                                      handleProceed();
                                }
                          }}
                    />
              )}  
            </>
      )
}

export default WithRoutify(SchoolNoteTab);
